import { createElementBlock as e, openBlock as l, createElementVNode as o } from "vue";
import a from "./index289.js";
const r = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function s(h, t, m, c, p, i) {
  return l(), e("svg", n, t[0] || (t[0] = [
    o("path", { d: "M43.5 40.75a1.25 1.25 0 0 1 .128 2.494l-.128.006h-27a1.25 1.25 0 0 1-.128-2.494l.128-.006h27Zm0-24a1.25 1.25 0 0 1 .128 2.494l-.128.006h-27a1.25 1.25 0 0 1-.128-2.494l.128-.006h27ZM21 24.745a1.25 1.25 0 0 1 .128 2.494l-.128.006h-4.5a1.25 1.25 0 0 1-.128-2.494l.128-.006H21Zm22.5 0a1.25 1.25 0 0 1 .128 2.494l-.128.006H27a1.25 1.25 0 0 1-.128-2.494l.128-.006h16.5Zm-12 8.01a1.25 1.25 0 0 1 .128 2.494l-.128.006h-15a1.25 1.25 0 0 1-.128-2.494l.128-.006h15Zm12 0a1.25 1.25 0 0 1 .128 2.494l-.128.006h-6a1.25 1.25 0 0 1-.128-2.494l.128-.006h6Z" }, null, -1)
  ]));
}
const f = /* @__PURE__ */ a(r, [["render", s]]);
export {
  f as default
};
